<template>
  <span>
    <template v-for="(part, index) in parts" :key="index">
      <a
        v-if="part.isLink"
        class="text-primary font-bold underline"
        :href="link.href"
        :target="link.target ?? '_blank'"
        rel="noopener"
        >{{ link.text }}</a
      >
      <template v-else>{{ part.text }}</template>
    </template>
  </span>
</template>

<script setup>
import { computed } from 'vue'
import { LINK_PLACEHOLDER } from '@/composables/notification'

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  link: {
    type: Object,
    default: null,
  },
})

/**
 * Titles stay interpolated rather than rendered with v-html: several
 * notifications build their title from user data (an event or company name),
 * which v-html would execute. Splitting on the placeholder keeps every text
 * segment escaped and still gives the sentence a real inline <a>.
 */
const parts = computed(() => {
  if (!props.link || !props.title.includes(LINK_PLACEHOLDER)) {
    return [{ text: props.title, isLink: false }]
  }

  return props.title
    .split(LINK_PLACEHOLDER)
    .flatMap((text, index) =>
      index === 0
        ? [{ text, isLink: false }]
        : [{ isLink: true }, { text, isLink: false }],
    )
})
</script>
